<template>
  <button
    id="recommend"
    @click.stop="onRecommend"
    v-if="this.isShareable()
    && shareOpts"
  >
    <i class="fas fa-share-alt"></i>
  </button>
</template>
<script>
import { spinnakerApi } from '../../js/SpinnakerApi.js'

export default {
  props: ['item'],
  data: function () {
    return {
      shareOpts: null
    }
  },
  async created () {
    if (this.isShareable()) {
      this.shareOpts = await spinnakerApi.getRecommendLink(this.item.progId)
    }
  },
  methods: {
    isShareable () {
      return (
        this.item.contentRights &&
        this.item.contentRights.indexOf('SocialShare') > -1 &&
        this.item.contentRights.indexOf('SocialSell') > -1
      )
    },
    onRecommend () {
      this.onShare(null, this.shareOpts.data)
    },
    onShare (e, item) {
      if (!item) {
        item = this.item
      }

      if (item.sharingUrl) {
        const share = item.sharingUrl
        const shareOpts = {
          title: item.title,
          // text: item.description,
          url: share,
          poster: item.image
        }
        this.$store.commit('share', shareOpts)
      } else {
        this.$store.commit('hideLoading')
      }
    }
  }
}
</script>
